export default class DatesUtils {
  static formatDate(date) {
    let year = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
    let month = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(date);
    let day = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date);
    return `${year}-${month}-${day}`;
  }

  static formatDateForDisplay(date) {
    let year = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
    let month = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(date);
    let day = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date);
    return `${day}/${month}/${year}`;
  }

  static format(date) {
    return new Intl.DateTimeFormat('sr-Latn-RS', {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: undefined,
      minute: undefined,
      second: undefined,
    }).format(date);
  }
}
